import { render, staticRenderFns } from "./ItemMenu.vue?vue&type=template&id=24588df2&scoped=true&"
import script from "./ItemMenu.vue?vue&type=script&lang=js&"
export * from "./ItemMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24588df2",
  null
  
)

export default component.exports